var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeroBlob(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 358,
    height: 499,
    viewBox: "0 0 358 499",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 174,
    width: 19.9828,
    height: 69.9399,
    rx: 9.99142,
    fill: "#FFF0F7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 19.9828,
    height: 69.9399,
    rx: 9.99142,
    fill: "#FFF0F7"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 149.871,
    y: 174,
    width: 19.9828,
    height: 69.9399,
    rx: 9.99142,
    fill: "#FFF0F7"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 149.871,
    width: 19.9828,
    height: 69.9399,
    rx: 9.99142,
    fill: "#FFF0F7"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 37.4688,
    y: 174,
    width: 19.9828,
    height: 69.9399,
    rx: 9.99142,
    fill: "#FFF0F7"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 37.4688,
    width: 19.9828,
    height: 69.9399,
    rx: 9.99142,
    fill: "#FFF0F7"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 187.34,
    y: 174,
    width: 19.9828,
    height: 69.9399,
    rx: 9.99142,
    fill: "#FFF0F7"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 187.34,
    width: 19.9828,
    height: 69.9399,
    rx: 9.99142,
    fill: "#FFF0F7"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 74.9355,
    y: 174,
    width: 19.9828,
    height: 69.9399,
    rx: 9.99142,
    fill: "#FFF0F7"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 74.9355,
    width: 19.9828,
    height: 69.9399,
    rx: 9.99142,
    fill: "#FFF0F7"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 224.807,
    y: 174,
    width: 19.9828,
    height: 69.9399,
    rx: 9.99142,
    fill: "#FFF0F7"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 174,
    width: 19.9828,
    height: 69.9399,
    rx: 9.99142,
    fill: "#FFF0F7"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 224.807,
    width: 19.9828,
    height: 69.9399,
    rx: 9.99142,
    fill: "#FFF0F7"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 300,
    width: 19.9828,
    height: 69.9399,
    rx: 9.99142,
    fill: "#FFF0F7"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 112.404,
    y: 174,
    width: 19.9828,
    height: 69.9399,
    rx: 9.99142,
    fill: "#FFF0F7"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 112.404,
    width: 19.9828,
    height: 69.9399,
    rx: 9.99142,
    fill: "#FFF0F7"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 262.275,
    y: 174,
    width: 19.9828,
    height: 69.9399,
    rx: 9.99142,
    fill: "#FFF0F7"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 337.469,
    y: 174,
    width: 19.9828,
    height: 69.9399,
    rx: 9.99142,
    fill: "#FFF0F7"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 262.275,
    width: 19.9828,
    height: 69.9399,
    rx: 9.99142,
    fill: "#FFF0F7"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 337.469,
    width: 19.9828,
    height: 69.9399,
    rx: 9.99142,
    fill: "#FFF0F7"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 149.871,
    y: 257.678,
    width: 19.9828,
    height: 69.9399,
    rx: 9.99142,
    fill: "#FFF0F7"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 149.871,
    y: 83.6782,
    width: 19.9828,
    height: 69.9399,
    rx: 9.99142,
    fill: "#FFF0F7"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    y: 257.678,
    width: 19.9828,
    height: 69.9399,
    rx: 9.99142,
    fill: "#FFF0F7"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    y: 83.6782,
    width: 19.9828,
    height: 69.9399,
    rx: 9.99142,
    fill: "#FFF0F7"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 187.34,
    y: 257.678,
    width: 19.9828,
    height: 69.9399,
    rx: 9.99142,
    fill: "#FFF0F7"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 187.34,
    y: 83.6782,
    width: 19.9828,
    height: 69.9399,
    rx: 9.99142,
    fill: "#FFF0F7"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 37.4688,
    y: 257.678,
    width: 19.9828,
    height: 69.9399,
    rx: 9.99142,
    fill: "#FFF0F7"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 37.4688,
    y: 83.6782,
    width: 19.9828,
    height: 69.9399,
    rx: 9.99142,
    fill: "#FFF0F7"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 224.807,
    y: 257.678,
    width: 19.9828,
    height: 69.9399,
    rx: 9.99142,
    fill: "#FFF0F7"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 257.678,
    width: 19.9828,
    height: 69.9399,
    rx: 9.99142,
    fill: "#FFF0F7"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 224.807,
    y: 83.6782,
    width: 19.9828,
    height: 69.9399,
    rx: 9.99142,
    fill: "#FFF0F7"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 83.6782,
    width: 19.9828,
    height: 69.9399,
    rx: 9.99142,
    fill: "#FFF0F7"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 74.9355,
    y: 257.678,
    width: 19.9828,
    height: 69.9399,
    rx: 9.99142,
    fill: "#FFF0F7"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 74.9355,
    y: 83.6782,
    width: 19.9828,
    height: 69.9399,
    rx: 9.99142,
    fill: "#FFF0F7"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 262.275,
    y: 257.678,
    width: 19.9828,
    height: 69.9399,
    rx: 9.99142,
    fill: "#FFF0F7"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 337.469,
    y: 257.678,
    width: 19.9828,
    height: 69.9399,
    rx: 9.99142,
    fill: "#FFF0F7"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 262.275,
    y: 83.6782,
    width: 19.9828,
    height: 69.9399,
    rx: 9.99142,
    fill: "#FFF0F7"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 337.469,
    y: 83.6782,
    width: 19.9828,
    height: 69.9399,
    rx: 9.99142,
    fill: "#FFF0F7"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 112.404,
    y: 257.678,
    width: 19.9828,
    height: 69.9399,
    rx: 9.99142,
    fill: "#FFF0F7"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 112.404,
    y: 83.6782,
    width: 19.9828,
    height: 69.9399,
    rx: 9.99142,
    fill: "#FFF0F7"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    y: 345,
    width: 19.9828,
    height: 69.9399,
    rx: 9.99142,
    fill: "#FFF0F7"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 149.871,
    y: 345,
    width: 19.9828,
    height: 69.9399,
    rx: 9.99142,
    fill: "#FFF0F7"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 37.4688,
    y: 345,
    width: 19.9828,
    height: 69.9399,
    rx: 9.99142,
    fill: "#FFF0F7"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 187.34,
    y: 345,
    width: 19.9828,
    height: 69.9399,
    rx: 9.99142,
    fill: "#FFF0F7"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 74.9355,
    y: 345,
    width: 19.9828,
    height: 69.9399,
    rx: 9.99142,
    fill: "#FFF0F7"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 224.807,
    y: 345,
    width: 19.9828,
    height: 69.9399,
    rx: 9.99142,
    fill: "#FFF0F7"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 345,
    width: 19.9828,
    height: 69.9399,
    rx: 9.99142,
    fill: "#FFF0F7"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 112.404,
    y: 345,
    width: 19.9828,
    height: 69.9399,
    rx: 9.99142,
    fill: "#FFF0F7"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 262.275,
    y: 345,
    width: 19.9828,
    height: 69.9399,
    rx: 9.99142,
    fill: "#FFF0F7"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 337.469,
    y: 345,
    width: 19.9828,
    height: 69.9399,
    rx: 9.99142,
    fill: "#FFF0F7"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 149.871,
    y: 428.678,
    width: 19.9828,
    height: 69.9399,
    rx: 9.99142,
    fill: "#FFF0F7"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    y: 428.678,
    width: 19.9828,
    height: 69.9399,
    rx: 9.99142,
    fill: "#FFF0F7"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 187.34,
    y: 428.678,
    width: 19.9828,
    height: 69.9399,
    rx: 9.99142,
    fill: "#FFF0F7"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 37.4688,
    y: 428.678,
    width: 19.9828,
    height: 69.9399,
    rx: 9.99142,
    fill: "#FFF0F7"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 224.807,
    y: 428.678,
    width: 19.9828,
    height: 69.9399,
    rx: 9.99142,
    fill: "#FFF0F7"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 428.678,
    width: 19.9828,
    height: 69.9399,
    rx: 9.99142,
    fill: "#FFF0F7"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 74.9355,
    y: 428.678,
    width: 19.9828,
    height: 69.9399,
    rx: 9.99142,
    fill: "#FFF0F7"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 262.275,
    y: 428.678,
    width: 19.9828,
    height: 69.9399,
    rx: 9.99142,
    fill: "#FFF0F7"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 337.469,
    y: 428.678,
    width: 19.9828,
    height: 69.9399,
    rx: 9.99142,
    fill: "#FFF0F7"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 112.404,
    y: 428.678,
    width: 19.9828,
    height: 69.9399,
    rx: 9.99142,
    fill: "#FFF0F7"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroBlob);
export default __webpack_public_path__ + "static/media/hero-blob.4f79cb529d76fcad40b4afc067c0d5f9.svg";
export { ForwardRef as ReactComponent };